import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';
import Lummus2ModelEditDto from '../dto/Lummus2ModelEditDto';

class Lummus2ModelEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'lummus2ModelEditControl';
	}

	/**
	 * @param {string} driverName
	 * @return {Promise<Lummus2ModelEditDto>}
	 */
	create(driverName) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/create`, { driverName })
				.then(response => resolve(new Lummus2ModelEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<Lummus2ModelEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new Lummus2ModelEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {Lummus2ModelEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {Lummus2ModelEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new Lummus2ModelEditService();
